<template>
  <landing-layout>
    <template slot="layout-left">
      <welcome-slogan />
    </template>
    <template slot="layout-right">
      <login-form :on-submit="submit" :errors="errors" :is-loading="isLoading" />
    </template>
  </landing-layout>
</template>

<script>
import LandingLayout from '@/components/layouts/LandingLayout.vue'
import WelcomeSlogan from '@/components/landing/WelcomeSlogan.vue'
import LoginForm from '@/components/landing/LoginForm.vue'
import { defaultPrivateRoute } from '@/router'

export default {
  components: {
    LandingLayout,
    WelcomeSlogan,
    LoginForm,
  },
  computed: {
    isLoading() {
      return this.$store.getters['security/isLoading']
    },
    errors() {
      return this.$store.getters['security/errors']
    },
  },
  methods: {
    async submit(payload) {
      const { redirect } = this.$route.query

      await this.$store.dispatch('security/login', payload)

      if (this.$store.getters['security/hasErrors'] === false) {
        if (typeof redirect !== 'undefined') {
          this.$router.push({ path: redirect })
        } else {
          this.$router.push({ name: defaultPrivateRoute })
        }
      }
    },
  },
  destroyed() {
    this.$store.dispatch('security/clearErrors')
  },
}
</script>
